import React, {
  ChangeEvent,
  FC,
  ForwardedRef,
  forwardRef,
  useEffect,
  useState,
} from "react";

import clsx from "clsx";

import { IconButton } from "../index";
import attentionIcon from "../../../resources/icons/attention.svg";

import styles from "./index.module.css";

type InputProps = {
  type: "text" | "password" | "email" | "number";
  label: string;
  isCenter?: boolean;
  error?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
};

const Input: FC<InputProps> = forwardRef(
  (props: InputProps, forwarded: ForwardedRef<HTMLInputElement>) => {
    const { type, label, error, isCenter, value, onChange, ...remainingProps } =
      props;
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
      value && setInputValue(value);
    }, [value]);

    const renderError = error?.length && (
      <div className={styles.errorContainer}>
        <IconButton icon={<img src={attentionIcon} alt="" />} tooltip={error} />
      </div>
    );

    function handleChangeValue(event: ChangeEvent<HTMLInputElement>) {
      setInputValue(event.target.value);
      onChange?.(event);
    }

    return (
      <div className={styles.container}>
        <input
          type={type}
          ref={forwarded}
          onChange={handleChangeValue}
          value={inputValue}
          className={clsx(styles.input, isCenter && styles.inputCenter)}
          placeholder={label}
          {...remainingProps}
        />
        {renderError}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
